import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function Modal({ open, title, onClose, children, footer, size = "", onSubmit }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    setTimeout(() => ref.current?.querySelector("input:not([type=hidden]), select, textarea, button.btn")?.focus(), 30);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  const Body = onSubmit ? "form" : "div";
  return createPortal(
    <div className="modal-wrap">
      <div className="modal-backdrop" onClick={onClose} />
      <Body
        className={`modal ${size === "lg" ? "modal--lg" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        ref={ref}
        onSubmit={
          onSubmit
            ? (e) => {
                e.preventDefault();
                onSubmit(e);
              }
            : undefined
        }
        noValidate
      >
        <div className="modal-head">
          <h2>{title}</h2>
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Close">
            <i className="bi bi-x-lg" />
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer ? <div className="modal-foot">{footer}</div> : null}
      </Body>
    </div>,
    document.body
  );
}
